import React, { useEffect, useState, Fragment } from 'react';
import { PageHeader } from '../../../Common';
import services from '../services';
import $ from 'jquery';
import authService from '../../Common/services';
import MessageModal from '../../../UI/Modal/MessageModal';
import { LoadingSpinerComponent } from '../../../Common/loader';
import { trackPromise } from 'react-promise-tracker';
import groupService from '../../Group/services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import Joi from '@hapi/joi';
import { CashPluckingRateMappingListingSchemaObject } from '../CashPluckingRateMappingSchema';
import { validate } from "../../Common";
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import Box from '@material-ui/core/Box';
import tokenService from '../../../Common/tokenDecoder';
import { IconButton } from '@material-ui/core';
import { Edit } from '@material-ui/icons';
const screenCode = 'CASHPLUCKINGRATEMAPPING';

export function CashPluckingRateMappingListing(props) {
    const [groups, setGroups] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [estates, setEstates] = useState([]);
    const [multipleEstates, setMultipleEstates] = useState([]);
    const [cashWorkTypes, setCashWorkTypes] = useState([]);
    const [errors, setErrors] = useState({});
    const [mappingArray, setMappingArray] = useState([]);
    const [IDDataForDeduction, setIsIDDataForDeduction] = useState(null);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    })
    const [isTableHidden, setIsTableHidden] = useState(true);
    const [isEnable, setIsEnable] = useState(true);
    const [cashPluckingRateMappingData, setCashPluckingRateMappingData] = useState({
        groupID: '0',
        estate: '0',
        configurationID: '0',
        divisionID: '0',
        jobTypeID: '0',
        cashWorkTypeID: '0',
        fromDate: new Date().toISOString().split('T')[0],
        toDate: new Date().toISOString().split('T')[0],
    });
    const [jobTypes, setJobTypes] = useState([]);
    const schema = Joi.object(CashPluckingRateMappingListingSchemaObject).options({ allowUnknown: true });
    useEffect(() => {
        getAllGroups();
        GetAllJobType();
    }, []);

    useEffect(() => {
        if (cashPluckingRateMappingData.groupID !== '0') {
            const getEstatesForDropdown = async () => {
                try {
                    const token = tokenService.getUserDetailsFromTokenV2();
                    if (!token || !token.operationEntities || token.operationEntities.length === 0) return;

                    const allEstates = await services.getEstatesByGroupID(cashPluckingRateMappingData.groupID);

                    const estateMap = {};
                    for (const item of Object.entries(token.operationEntities)) {
                        const entity = item[1];
                        estateMap[entity.OperationEntityID] = entity.OperationEntityName;
                    }

                    const filteredEstates = {};

                    if (Array.isArray(allEstates)) {
                        for (let i = 0; i < allEstates.length; i++) {
                            const item = allEstates[i];

                            // Skip empty/undefined slots
                            if (!item) continue;

                            // If item is a string (estate name), check if it matches token permissions
                            if (typeof item === 'string') {
                                // Check if this estate name exists in our permissions
                                const matchingEntityId = Object.keys(estateMap).find(id =>
                                    estateMap[id] === item
                                );

                                if (matchingEntityId) {
                                    // Add to object with ID as key and name as value
                                    filteredEstates[matchingEntityId] = item;
                                }
                            }
                            // If item is an object with OperationEntityID property
                            else if (item && typeof item === 'object' && item.OperationEntityID) {
                                if (estateMap[item.OperationEntityID]) {
                                    filteredEstates[item.OperationEntityID] = item.OperationEntityName;
                                }
                            }
                        }
                    }
                    setEstates(filteredEstates);

                } catch (error) {
                    console.error('❌ Error fetching estates:', error);
                }
            };
            getEstatesForDropdown();
        }
    }, [cashPluckingRateMappingData.groupID]);
    useEffect(() => {
        setMultipleEstates([]);
    }, []);


    useEffect(() => {
        if (cashPluckingRateMappingData.estate !== '0') {
            getDivisionsForDropDown();
        }
    }, [cashPluckingRateMappingData.estate]);

    useEffect(() => {
        const IDdata = JSON.parse(
            sessionStorage.getItem('cashPluckingRateMapping-page-search-parameters-id')
        );
        getPermissions(IDdata);
    }, []);
    useEffect(() => {
        if (IDDataForDeduction !== null) {
            handleSearch();
        }
    }, [IDDataForDeduction]);
    useEffect(() => {
        sessionStorage.removeItem(
            'cashPluckingRateMapping-page-search-parameters-id'
        );
    }, [])

    useEffect(() => {
        if (cashPluckingRateMappingData.jobTypeID !== '0') {
            GetAllCashWorkTypeByJobType();
        }
    }, [cashPluckingRateMappingData.jobTypeID]);

    const handleChange = (e) => {
        validateInputs(e.target);
        if (e.target.name === "groupID") {
            setCashPluckingRateMappingData({
                ...cashPluckingRateMappingData,
                [e.target.name]: e.target.value,
                estate: '0',
                divisionID: '0',
                jobTypeID: '0',
                cashWorkTypeID: '0',
                fromDate: new Date().toISOString().split('T')[0],
                toDate: new Date().toISOString().split('T')[0],
            });
            setMultipleEstates([]);
        }
        else if (e.target.name === "estate") {
            setCashPluckingRateMappingData({
                ...cashPluckingRateMappingData,
                [e.target.name]: e.target.value,
                divisionID: '0',
                jobTypeID: '0',
                cashWorkTypeID: '0',
                fromDate: new Date().toISOString().split('T')[0],
                toDate: new Date().toISOString().split('T')[0],
            });
        } else if (e.target.name === "divisionID") {
            setCashPluckingRateMappingData({
                ...cashPluckingRateMappingData,
                [e.target.name]: e.target.value,
                jobTypeID: '0',
                cashWorkTypeID: '0',
                fromDate: new Date().toISOString().split('T')[0],
                toDate: new Date().toISOString().split('T')[0],
            });
        } else {
            setCashPluckingRateMappingData({
                ...cashPluckingRateMappingData,
                [e.target.name]: e.target.value
            });
        }
        setMappingArray([]);
    };

    function handleFromDateChange(target) {
        const newFromDate = target.value;

        setCashPluckingRateMappingData(prevState => ({
            ...prevState,
            fromDate: newFromDate,
        }));
    }

    function handleToDateChange(target) {
        const newToDate = target.value;

        setCashPluckingRateMappingData(prevState => ({
            ...prevState,
            toDate: newToDate
        }));
    }

    function handleClick(item) {
        let model = {
            groupID: parseInt(cashPluckingRateMappingData.groupID),
            estate: parseInt(cashPluckingRateMappingData.estate),
            divisionID: parseInt(cashPluckingRateMappingData.divisionID),
            jobTypeID: parseInt(cashPluckingRateMappingData.jobTypeID),
            cashWorkTypeID: parseInt(cashPluckingRateMappingData.cashWorkTypeID),
            fromDate: cashPluckingRateMappingData.fromDate,
            toDate: cashPluckingRateMappingData.toDate,
        }
        sessionStorage.setItem('cashPluckingRateMapping-page-search-parameters-id', JSON.stringify(model));
        props.history.push({
            pathname: 'CashPluckingRateMapping/addEdit',
            data: item,
            edit: true
        })
    }

    async function handleSearch(e) {
        if (e && e.preventDefault) {
            e.preventDefault();
        }

        const errorMessages = validate(schema, cashPluckingRateMappingData);
        if (errorMessages) {
            setErrors(errorMessages);
            return;
        } else {
            setErrors({});
        }

        let model = {
            groupID: parseInt(cashPluckingRateMappingData.groupID),
            operationEntityID: parseInt(cashPluckingRateMappingData.estate),
            collectionPointID: parseInt(cashPluckingRateMappingData.divisionID),
            jobTypeID: parseInt(cashPluckingRateMappingData.jobTypeID),
            cashWorkTypeID: parseInt(cashPluckingRateMappingData.cashWorkTypeID),
            fromDate: cashPluckingRateMappingData.fromDate,
            toDate: cashPluckingRateMappingData.toDate,
        }
        const response = await services.GetCashPluckingRateMappingData(model);
        if (!response.data || response.data.length === 0 || response.data.statusCode === "Error") {
            setMessageModel({ hidden: false, type: "Error", disciption: "No records to display" });
            setMappingArray([]);
            setIsTableHidden(true);
            afterUnsuccessfulyChanged("Error");
            return;
        }
        setMappingArray(response.data);
        setIsTableHidden(false);
    }

    function afterUnsuccessfulyChanged(response) {
        if (response === "Error") {
            setTimeout(() => {
                setMessageModel({ hidden: true, type: "Error", disciption: "" });
            }, 4000);
        }
    }
    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    async function getPermissions(IDdata) {
        const permissions = await authService.getPermissionsByScreen(screenCode);
        const isAuthorized = permissions.find(p => p.permissionCode === 'VIEWCASHPLUCKINGRATEMAPPING');
        if (!isAuthorized) {
            props.history.push('/unauthorized');
        }

        const isGroupFilterEnabled = permissions.find(p => p.permissionCode === 'GROUPDROPDOWN');
        const isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode === 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromTokenV2();

        const initialValues = IDdata === null;
        if (initialValues) {

            setCashPluckingRateMappingData({
                ...cashPluckingRateMappingData,
                groupID: token.groupID,
                estate: token.operationEntityID
            })

        }
        else {
            const formatDateString = (dateStr) => {
                const date = new Date(dateStr);
                return date.getFullYear() + '-' +
                    String(date.getMonth() + 1).padStart(2, '0') + '-' +
                    String(date.getDate()).padStart(2, '0');
            };

            setCashPluckingRateMappingData(prev => ({
                ...prev,
                groupID: IDdata.groupID,
                estate: IDdata.estate,
                divisionID: IDdata.divisionID,
                jobTypeID: IDdata.jobTypeID,
                cashWorkTypeID: IDdata.cashWorkTypeID,
                fromDate: IDdata.fromDate ? formatDateString(IDdata.fromDate) : '',
                toDate: IDdata.toDate ? formatDateString(IDdata.toDate) : '',
            }));

            setIsIDDataForDeduction(IDdata)
        }
    }

    async function getAllGroups() {
        const data = await groupService.getGroupsForDropdown();
        setGroups(data);
    }

    async function getEstatesForDropdown() {
        const data = await services.getEstatesByGroupID(cashPluckingRateMappingData.groupID);
        setEstates(data);
    }

    async function GetAllCashWorkTypeByJobType() {
        const data = await services.GetAllCashWorkTypeByJobType(cashPluckingRateMappingData.jobTypeID);
        setCashWorkTypes(data);
    }


    async function getDivisionsForDropDown() {
        const data = await services.getDivisionByEstateID(cashPluckingRateMappingData.estate);
        setDivisions(data);
    }

    function generateDropDownMenu(data) {
        return Object.entries(data || {}).map(([key, value]) => (
            <MenuItem key={key} value={key}>{value}</MenuItem>
        ));
    }

    function validateInputs(target) {
        const error = { ...errors };
        delete error[target.name];
        setErrors(error);
    }

    const formatDateString = (dateStr) => {
        const date = new Date(dateStr);
        return date.getFullYear() + '-' +
            String(date.getMonth() + 1).padStart(2, '0') + '-' +
            String(date.getDate()).padStart(2, '0');
    };

    async function GetAllJobType() {
        const data = await services.GetAllJobType();
        setJobTypes(data);
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title="Cash Plucking Rate Mapping"
                            isButtonEnable={true}
                            buttonText="Add Cash Plucking Rate Mapping"
                            path="CashPluckingRateMapping/addEdit"
                        />
                        <form>
                            <div className="card-body">
                                <div className="form-group row">
                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            disabled={!isEnable || !permissionList.isGroupFilterEnabled}
                                            value={cashPluckingRateMappingData.groupID}
                                            onChange={handleChange}>

                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText error>{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="estate">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estate"
                                            id="estate"
                                            name="estate"
                                            disabled={!isEnable || !permissionList.isOperationEntityFilterEnabled}
                                            value={cashPluckingRateMappingData.estate}
                                            onChange={handleChange}>
                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(multipleEstates.length == 0 ? estates : multipleEstates)}
                                        </Select>
                                        {errors["estate"] && <FormHelperText error>{errors["estate"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="divisionID">Collection Point *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="divisionID"
                                            id="divisionID"
                                            name="divisionID"
                                            value={cashPluckingRateMappingData.divisionID}
                                            disabled={!isEnable}
                                            onChange={handleChange}>
                                            <MenuItem value="0">--Select Collection Point--</MenuItem>
                                            {generateDropDownMenu(divisions)}
                                        </Select>
                                        {errors["divisionID"] && <FormHelperText error>{errors["divisionID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="jobTypeID">JobType *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="jobTypeID"
                                            id="jobTypeID"
                                            name="jobTypeID"
                                            value={cashPluckingRateMappingData.jobTypeID}
                                            disabled={!isEnable}
                                            onChange={handleChange}>
                                            <MenuItem value="0">--Select Job Type--</MenuItem>
                                            {generateDropDownMenu(jobTypes)}
                                        </Select>
                                        {errors["jobTypeID"] && <FormHelperText error>{errors["jobTypeID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="cashWorkTypeID">Cash Work Type </InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="cashWorkTypeID"
                                            id="cashWorkTypeID"
                                            name="cashWorkTypeID"
                                            value={cashPluckingRateMappingData.cashWorkTypeID}
                                            disabled={!isEnable}
                                            onChange={handleChange}>
                                            <MenuItem value="0">--Select Cash Work Type--</MenuItem>
                                            {generateDropDownMenu(cashWorkTypes)}
                                        </Select>
                                        {errors["cashWorkTypeID"] && <FormHelperText error>{errors["cashWorkTypeID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="fromDate">From Date </InputLabel>
                                        <TextField
                                            fullWidth
                                            id="fromDate"
                                            name="fromDate"
                                            type="date"
                                            value={cashPluckingRateMappingData.fromDate}
                                            disabled={!isEnable}
                                            onChange={(e) => handleFromDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["fromDate"] && <FormHelperText error>{errors["fromDate"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="todate">To Date </InputLabel>
                                        <TextField
                                            fullWidth
                                            id="toDate"
                                            name="toDate"
                                            type="date"
                                            value={cashPluckingRateMappingData.toDate}
                                            disabled={!isEnable}
                                            onChange={(e) => handleToDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["toDate"] && <FormHelperText error>{errors["toDate"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md-12">
                                        <input
                                            type="submit"
                                            className="btn btn-primary"
                                            value="Search"
                                            disabled={!isEnable}
                                            onClick={handleSearch}
                                        />
                                    </div>
                                </div>
                                {mappingArray.length > 0 && (
                                    <Box display="flex" justifyContent="flex-end" p={2} hidden={isTableHidden}>
                                        <TableContainer component={Paper}>
                                            <Table aria-label="simple table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell align="center" style={{ fontWeight: "bold" }}>Division</TableCell>
                                                        <TableCell align="center" style={{ fontWeight: "bold" }}>Cash Work Type</TableCell>
                                                        <TableCell align="center" style={{ fontWeight: "bold" }}>From Date</TableCell>
                                                        <TableCell align="center" style={{ fontWeight: "bold" }}>To Date</TableCell>
                                                        <TableCell align="center" style={{ fontWeight: "bold" }}>Rate</TableCell>
                                                        <TableCell align="center" style={{ fontWeight: "bold" }}>Action</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {mappingArray.map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell align="center">{row.collectionPointName}</TableCell>
                                                            <TableCell align="center">{row.cashWorkTypeName}</TableCell>
                                                            <TableCell align="center">{formatDateString(row.fromDate)}</TableCell>
                                                            <TableCell align="center">{formatDateString(row.toDate)}</TableCell>
                                                            <TableCell align="center">{row.rate.toFixed(2)}</TableCell>
                                                            <TableCell align="center">
                                                                <IconButton onClick={() => handleClick(row)}>
                                                                    <Edit color="black" />
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Box>
                                )}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}
